let shouldDetectTrackpad = true;
let isTrackPad;
let eventCount = 0;
let eventCountStart;
const detectTrackpad = (_) => {
  const isTrackPadDefined = typeof isTrackPad !== "undefined";
  if (isTrackPadDefined && !shouldDetectTrackpad) return;
  if (eventCount === 0) {
    eventCountStart = performance.now();
  }
  eventCount++;
  if (performance.now() - eventCountStart > 66) {
    if (eventCount > 5) {
      isTrackPad = true;
    } else {
      isTrackPad = false;
    }
    shouldDetectTrackpad = false;
    setTimeout(() => {
      shouldDetectTrackpad = true;
      eventCount = 0;
      eventCountStart = void 0;
    }, 1e4);
  }
};
const Trackpad = {
  detect: detectTrackpad,
  isTrackpad: () => isTrackPad
};

export { Trackpad, detectTrackpad };
//# sourceMappingURL=detectTrackpad.js.map
